module.exports = __webpack_public_path__ + "fj.svg?453532c2daca1423d88f079a82cfcfc5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/fj.svg
// module id = 1351
// module chunks = 0